module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Clothes/Panties-4b9c2a7f1c08586ce62b42ae748223e7.svg";